export default function Excel_Charts() {
  return <div>Excel_Charts</div>;
}
